import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { deepLink } from '@erp-attach/shared';
import { useApiQuery } from '../api/useApiQuery';
import { ApiRequestError } from '../api/client';
import { config } from '../config';
import { addRecent, notifyRecentChange } from '../lib/recent';
import { routes } from '../lib/links';
import { EntityHeader } from '../components/EntityHeader';
import { FolderWorkspace } from '../components/FolderWorkspace';
import { ProvisioningState } from '../components/ProvisioningState';
import { ErrorBanner } from '../components/ui/ErrorBanner';
import { FullPageSpinner } from '../components/ui/Spinner';
import { NotFoundPage } from './NotFoundPage';

export function SupplierPage() {
  const { supplierNumber = '' } = useParams();
  const query = useApiQuery((api, signal) => api.suppliers.get(supplierNumber, signal), [supplierNumber]);
  const data = query.data;

  useEffect(() => {
    if (data?.status === 'ready') {
      addRecent({
        kind: 'supplier',
        number: data.entity.supplierNumber,
        label: data.entity.name,
        href: routes.supplier(data.entity.supplierNumber),
      });
      notifyRecentChange();
    }
  }, [data]);

  if (query.loading) return <FullPageSpinner label="Loading supplier" />;
  if (query.error) {
    if (query.error instanceof ApiRequestError && query.error.isNotFound) return <NotFoundPage what="supplier" />;
    return <ErrorBanner title="Supplier could not be loaded" error={query.error} />;
  }
  if (!data) return null;
  if (data.status === 'provisioning') {
    return (
      <ProvisioningState kind="supplier" number={data.entity.number || supplierNumber} name={data.entity.name} onRetry={query.reload} />
    );
  }

  const { entity, folders } = data;
  return (
    <div className="space-y-4">
      <EntityHeader
        kind="supplier"
        crumbs={[{ label: 'Suppliers', href: routes.browseSuppliers }]}
        name={entity.name}
        number={entity.supplierNumber}
        status={entity.status}
        deepLink={deepLink.supplier(entity.supplierNumber, config.appBaseUrl)}
      />
      <FolderWorkspace entityType="supplier" folders={folders} />
    </div>
  );
}
